// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1aTZt","boxTitle":"Qualiphy_boxTitle__31c01","box":"Qualiphy_box__34wEq","toggleWrap":"Qualiphy_toggleWrap__3ksNu"};